import { toast } from 'react-toastify';

// Toast mesajları için ortak konfigürasyon
const toastConfig = {
  position: "top-center",
  autoClose: 4000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined
};

// Özel toast bileşeni oluşturma fonksiyonu
const createToastContent = (icon, title, message, onClick = null) => (
  <div className="custom-toast" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
    <div className="toast-icon" style={{ color: '#ffc107' }}>{icon}</div>
    <div className="toast-content">
      <div className="toast-title">{title}</div>
      <div className="toast-message">{message}</div>
      {onClick && <div className="toast-action">Sepete git &rarr;</div>}
    </div>
  </div>
);

// Başarı mesajı
export const showSuccessToast = (message, title = "Başarılı", onClick = null) => {
  toast.success(
    createToastContent('🛒', title, message, onClick),
    {
      ...toastConfig,
      className: 'toast-success',
      bodyClassName: 'toast-body',
      progressClassName: 'toast-progress-success',
      onClick: onClick
    }
  );
};

// Hata mesajı
export const showErrorToast = (message, title = "Hata", icon = '⚠️') => {
  toast.error(
    createToastContent(icon, title, message),
    {
      ...toastConfig,
      className: 'toast-error',
      bodyClassName: 'toast-body',
      progressClassName: 'toast-progress-warning'
    }
  );
};

// Uyarı mesajı
export const showWarningToast = (message, title = "Uyarı", icon = '⚠️') => {
  toast.warning(
    createToastContent(icon, title, message),
    {
      ...toastConfig,
      className: 'toast-warning',
      bodyClassName: 'toast-body',
      progressClassName: 'toast-progress-warning'
    }
  );
};

// Bilgi mesajı
export const showInfoToast = (message, title = "Bilgi", icon = 'ℹ️') => {
  toast.info(
    createToastContent(icon, title, message),
    {
      ...toastConfig,
      className: 'toast-info',
      bodyClassName: 'toast-body',
      progressClassName: 'toast-progress-info'
    }
  );
};

// Özel mesajlar
export const showModelNotSelectedToast = () => {
  toast.error('Lütfen bir cihaz modeli seçin.');
};

export const showColorNotSelectedToast = () => {
  toast.error('Lütfen bir renk seçin.');
};

export const showModelNotFoundToast = () => {
  toast.error('Seçilen model bulunamadı.');
};

export const showColorsLoadingToast = () => {
  toast.info('Renk seçenekleri yükleniyor, lütfen bekleyin.');
};

// Sepete ekleme başarı mesajı - tıklandığında sepet sayfasına yönlendirir
export const showAddedToCartToast = (onClickCallback) => {
  showSuccessToast('Ürün sepete eklendi', 'Başarılı', onClickCallback);
};

export const showCartErrorToast = (errorMessage = 'Sepete eklenirken bir hata oluştu') => {
  showErrorToast(errorMessage);
};

export default {
  showSuccessToast,
  showErrorToast,
  showWarningToast,
  showInfoToast,
  showModelNotSelectedToast,
  showColorNotSelectedToast,
  showModelNotFoundToast,
  showColorsLoadingToast,
  showAddedToCartToast,
  showCartErrorToast
}; 